import { nameTitleOptions } from "@/dentlab/src/lib/constants/nameTitle";
import { SelectProps } from "../../form-types";
import { CustomAutocomplete } from "../../../components/custom-autocomplete.component";
import { CustomAutocompleteShadcn } from "../../../components/custom-autocomplete-shadcn.component";

export const TitleSelect: React.FC<SelectProps> = (props) => {
	return (
		<CustomAutocomplete
			options={nameTitleOptions}
			inputLabel="Anrede"
			{...props}
		/>
	);
};

export const TitleSelectShadcn: React.FC<
	SelectProps & { className?: string }
> = (props) => {
	return (
		<CustomAutocompleteShadcn
			options={nameTitleOptions}
			inputLabel="Anrede"
			allowFreeText
			{...props}
		/>
	);
};
